module.exports = __webpack_public_path__ + "static/media/ic_avatar_default.eaeebc15.svg";